import { css, keyframes } from "styled-components";

export const EASE = "cubic-bezier(0.2, 0.8, 0.2, 1)";

export const popIn = keyframes`
  from { opacity: 0; transform: translateY(4px) scale(0.96); }
  to { opacity: 1; transform: none; }
`;

export const reducedMotion = css`
  @media (prefers-reduced-motion: reduce) {
    animation: none;
    transition: none;
  }
`;
